import React from 'react'
import formConfig from "../../../formJsonData/Purchase/DepartmentMaster/DepartmentForm.json"
import Forms from '../../../components/common/Form';
import searchConfigJson from "../../../formJsonData/LMS/searchFilterFields.json"

const DepartmentForm = () => {
  return (
    <div>
      <Forms formConfig={formConfig} searchConfigJson={searchConfigJson.branchmasterList}/>
    </div>
  )
}

export default DepartmentForm
